import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GlobalModalComponent } from 'src/ui/layout/global-modal/global-modal.component';
import { ToastComponent } from 'src/ui/components/toast/toast.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, GlobalModalComponent, ToastComponent],
  templateUrl: './app.component.html',
})
export class AppComponent {}
